import { useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";

interface Crumb {
  label: string;
  path?: string; // optional for the current page
}

interface BreadcrumbsProps {
  crumbs: Crumb[];
}

const Breadcrumbs = ({ crumbs }: BreadcrumbsProps) => {
  const navigate = useNavigate();

  return (
    <nav className="text-sm text-gray-600 dark:text-gray-400 mb-4 flex items-center flex-wrap gap-1 ml-1">
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;
        return (
          <span key={index} className="flex items-center gap-1">
            {!isLast && crumb.path ? (
              <button
                onClick={() => navigate(crumb.path!)}
                className="text-gray-600 dark:text-gray-400 hover:underline"
              >
                {crumb.label}
              </button>
            ) : (
              <span className="font-medium text-blue-800 dark:text-blue-400">
                {crumb.label}
              </span>
            )}
            {!isLast && (
              <span className="mx-1 text-black-400 dark:text-gray-400">
                <FaAngleRight size={16} />
              </span>
            )}
          </span>
        );
      })}
    </nav>
  );
};

export default Breadcrumbs;
